<template>
	<div>
		<el-dialog
			:title="dialogControl.title"
			:visible.sync="dialogControl.visible"
			width="1029px"
			class="sing-synchroel-dialog"
      :close-on-click-modal="false"
		>
			<div v-if="dialogControl.visible" class="sing-synchroel-container">
				<div
					class="progress"
					@click.self="
						activePoint = {
							time: undefined,
							index: undefined,
							mill: undefined
						}
					"
				>
					<!-- 卡点标记点 -->
					<div class="w-flex w-flex-items-end w-mb-[-5px]">
						<span class="w-pr-5px w-text-[#fff] w-text-18px w-w-56px w-h-21px"></span>
						<div class="points" ref="points" style="flex: 1">
							<div
								v-for="(point, i) in renderPoints"
								:key="point.time"
								class="w-absolute w-cursor-pointer"
								_w="14px"
								@click="selectPoint(point, i)"
								@mousedown="e => pointMousedown(i)"
								:ref="'point-' + i"
								:style="{ left: `calc(${point.parcent}% - 7px)` }"
							>
								<template v-if="point.type == 'music'">
									<img
										v-if="activePoint.index == i"
										_w="14px"
										:src="require('@/assets/image/synchroel-point-music-on.png')"
									/>
									<img v-else _w="14px" :src="require('@/assets/image/synchroel-point-music-off-active.png')" />
								</template>
								<template v-else>
									<img
										v-if="activePoint.index == i"
										_w="14px"
										:src="require('@/assets/image/synchroel-point-active.png')"
									/>
									<img v-else _w="14px" :src="require('@/assets/image/synchroel-points.png')" />
								</template>
							</div>
						</div>
						<span class="w-pl-10px w-text-[#fff] w-text-18px w-w-56px w-h-21px"></span>
					</div>
					<!-- 播放器 -->
					<audio
						:src="formData.fanchangUrl"
						ref="audio"
						@canplay="canplay"
						@timeupdate="timeupdate"
						@pause="audioPause"
						@playing="() => (audioControl.isPlaying = true)"
					></audio>
					<!-- 进度条 -->
					<div class="progress-box">
						<span class="w-pr-5px w-w-56px">00:00</span>
						<!-- <div
							v-if="activePoint.time != undefined && activePoint.time > 0"
							class="point-control can-btn w-mr-20px"
							@click=";(formData.points[activePoint.index].time -= 0.01), (activePoint.time -= 0.01)"
						>
							<i class="el-icon-caret-left w-text-20px"></i>
						</div>
						<div v-else class="point-control w-mr-20px">
							<i class="el-icon-caret-left w-text-20px"></i>
						</div> -->
						<div _flex="1" style="width: 837px">
							<el-progress
								style="flex: 1"
								:percentage="audioControl.playParcent"
								color="#FF5E2A"
								:show-text="false"
								:stroke-width="8"
								:duration="0"
							/>
						</div>
						<!-- <div
							v-if="activePoint.time != undefined && activePoint.time < audioControl.duration"
							class="point-control can-btn w-ml-20px"
							@click=";(formData.points[activePoint.index].time += 0.01), (activePoint.time += 0.01)"
						>
							<i class="el-icon-caret-right w-text-20px"></i>
						</div>
						<div v-else class="point-control w-ml-20px">
							<i class="el-icon-caret-right w-text-20px"></i>
						</div> -->
						<span class="w-pl-10px w-w-56px w-h-21px">{{ timeFormat(audioControl.currentTime) }}</span>
					</div>
					<!-- 卡点时间 -->
					<div class="w-flex w-flex-items-center w-h-18px w-mt-[0]">
						<span class="w-pr-5px w-text-[#fff] w-text-18px w-w-56px w-h-21px"></span>
						<div class="point-times w-flex-1 w-text-18px">
							<span
								v-for="(point, i) in renderPoints"
								:key="point.time"
								class="w-absolute w-text-[#818181]"
								_w="100px"
								:style="{
									left: `calc(${point.parcent}% - 40px)`,
									color: activePoint.index == i ? '#ff5e2a' : undefined
								}"
							>
								<span v-if="activePoint.index == i"> {{ timeFormat(point.time, false, true) }} </span>
							</span>
						</div>
						<span class="w-pl-10px w-text-[#fff] w-text-18px w-w-56px w-h-21px"></span>
					</div>
				</div>
				<div class="sing-synchroel-ctx">
					<div class="ctx-lyric">
						<div class="ctx-lyric-title">
							歌词
							<!-- <span style="flex: 1">（一行一句，一句最多50字）</span> -->
							<span style="flex: 1">（一行一句）</span>
							<el-button
								type="primary"
								@click="writeLyric"
								size="small"
								_w="88px"
								:disabled="!abc_json_val.lyricArr?.length"
							>
								填入歌词
							</el-button>
						</div>
						<el-input
							class="ctx-lyric-list"
							type="textarea"
							:autosize="{ minRows: 10.3, maxRows: 10.3 }"
							resize="none"
							placeholder="输入歌词"
							v-model="formData.lyric"
							@input="isModify = true"
						>
						</el-input>
					</div>
					<div class="ctx-controls">
						<div class="music-upload">
							<div class="upload-item">
								<div class="mp3-icon">
									<img v-if="formData.fanchangUrl" _w="60px" :src="require('@/assets/test_client/Group.png')" />
									<i v-else class="el-icon-plus"></i>
								</div>
								<div class="upload-text">演唱</div>
							</div>
							<div class="upload-item">
								<div class="mp3-icon">
									<img v-if="formData.banchangUrl" _w="60px" :src="require('@/assets/test_client/Group.png')" />
									<i v-else class="el-icon-plus"></i>
								</div>
								<div class="upload-text">伴奏</div>
							</div>
						</div>
						<div _flex="~ items-center" _mt="25px">
							<div _text="16px [#323232]" _mr="10px">预备拍</div>
							<el-input-number
								v-model="formData.beat"
								controls-position="right"
								style="width: 100px"
								:min="1"
								:max="10"
							></el-input-number>
							<div _text="16px [#323232]" _ml="10px">下</div>

							<div _text="16px [#323232]" _mx="30px">卡点</div>
							<el-input-number
								v-model="activePoint.mill"
								ref="millRef"
								controls-position="right"
								:step="0.01"
								:disabled="!activePoint.time"
								style="width: 100px"
								@change="activePointTimeChange"
							></el-input-number>
							<div _text="16px [#323232]" _ml="10px">毫秒</div>
						</div>
						<div
							_flex="~ items-center justify-between"
							_h="65px"
							_bg="[#fff]"
							_mt="25px"
							_border="rounded-3px 1px solid [#C9C9C9]"
							_p="15px"
							_px="20px"
							_box="border"
						>
							<div _flex="~ items-center justify-center" _w="20px" _h="20px" _box="border" class="w-cursor-pointer">
								<img
									v-if="audioControl.isPlaying"
									@click="pause"
									:src="require('@/assets/image/synchroel-pause.png')"
									_w="20px"
								/>
								<img v-else @click="play" :src="require('@/assets/image/synchroel-paly.png')" _w="20px" />
							</div>
							<div _flex="~ items-center justify-center" _w="20px" _h="20px" class="w-cursor-pointer" @click="pause">
								<img @click="stop" :src="require('@/assets/image/synchroel-stop.png')" _w="18px" />
							</div>
							<div
								_flex="~ items-center justify-center"
								_w="70px"
								_h="32px"
								_bg="[#f2f2f2]"
								_border="rounded-4px"
								_pointer="~"
								class="w-cursor-pointer"
								@click="markerPoint"
							>
								<img :src="require('@/assets/image/synchroel-point.png')" _w="16px" _mr="5px" />
								卡点
							</div>
							<div
								_flex="~ items-center justify-center"
								_w="100px"
								_h="32px"
								_bg="[#f2f2f2]"
								_border="rounded-4px"
								_pointer="~"
								class="w-cursor-pointer"
								@click="setPointMusic"
							>
								<img :src="require('@/assets/image/synchroel-music-on.png')" _w="16px" _mr="5px" />
								<span v-if="renderPoints[activePoint.index]?.type != 'music'">设为</span>
								<span v-else>取消</span>
								伴奏
							</div>
							<div
								_flex="~ items-center justify-center"
								_w="70px"
								_h="32px"
								_bg="[#f2f2f2]"
								_border="rounded-4px"
								class="w-cursor-pointer"
								@click="deletePoint"
							>
								<i class="el-icon-delete" _mr="5px"></i>
								删除
							</div>
							<div
								_flex="~ items-center justify-center"
								_w="70px"
								_h="32px"
								_bg="[#f2f2f2]"
								_border="rounded-4px"
								class="w-cursor-pointer"
								@click="resetPoints"
							>
								<i class="el-icon-refresh-right" _mr="5px"></i>
								重置
							</div>
						</div>
						<el-button
							type="primary"
							@click="openPreview"
							size="small"
							_w="88px"
							:disabled="!formData.fanchangUrl || !formData.banchangUrl || !formData.lyric || !formData.points.length"
							style="margin-top: 25px"
						>
							预览
						</el-button>
						<!-- <el-button
							type="primary"
							size="small"
							_w="88px"
							:disabled="!formData.fanchangUrl || !formData.banchangUrl || !formData.lyric || !formData.points.length"
							style="margin-top: 25px;"
						>
							预览
						</el-button> -->
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogControl.visible = false" style="margin-right: 40px" size="small" _w="88px">
					取 消
				</el-button>
				<el-button
					type="primary"
					:disabled="
						!formData.fanchangUrl || !formData.banchangUrl || !formData.lyric || !formData.points.length || !isModify
					"
					@click="saveData"
					size="small"
					_w="88px"
				>
					保 存
				</el-button>
			</span>
		</el-dialog>

		<Preview ref="preview" />
	</div>
</template>

<script>
import axios from 'axios'
import SingSynchroPreview from './SingSynchroPreview.vue'
import moment from 'moment'

export default {
	components: { Preview: SingSynchroPreview },
	data() {
		return {
			id: '',
			musciData: {},
			abcContent: '',
			dialogControl: {
				title: '跟唱同步',
				visible: false
			},
			oldAyncJsonVal: '', // 旧数据
			// 谱音abcContent，数据，解析后的歌词
			abc_json_val: {
				url: '',
				lyricArr: []
			},
			activePoint: {
				time: undefined,
				index: undefined,
				mill: undefined
			},
			formData: {
				name: '',
				/** @type {{ time: number, type: 'point' | 'music' }[]} */
				points: [], // 卡点
				fanchangUrl: '', // 范唱
				banchangUrl: '', // 伴唱
				beat: 1, // 拍子数
				lyric: '' // 歌词字符串
			},
			audioControl: {
				isPlaying: false, // 是否正在播放
				duration: 0, // 总播放时长/s
				currentTime: 0, // 当前播放时间/s
				playParcent: 0 // 当前播放时长，进度百分比/%
			}
		}
	},
	watch: {
		'activePoint.time'(val) {
			const time = moment.duration(val || 0, 'seconds')
			this.activePoint.mill = +time.milliseconds().toFixed(0)
		}
	},
	computed: {
		// 时间格式化 秒 ->  分：秒
		timeFormat() {
			return function (duration, a = false, b = false) {
				return this.timeFormatFn(duration, a, b)
			}
		},
		renderPoints() {
			let duration = this.audioControl.duration
			if (duration == 0) return []
			return this.formData.points.map(point => {
				return {
					...point,
					position: 0,
					// parcent: parseInt((point.time / duration) * 100)
					parcent: +((point.time / duration) * 100).toFixed(1)
				}
			})
		},
		// 对比数据是否修改了内容
		isModify() {
			let oldVal = JSON.parse(this.oldAyncJsonVal)
			if (JSON.stringify(oldVal.points) !== JSON.stringify(this.formData.points)) return true
			if (oldVal.beat !== this.formData.beat) return true
			if (this.formData.lyric !== oldVal.lyric) return true
			return false
		}
	},
	methods: {
		timeFormatFn(seconds, isHours = false, isMill = false) {
			moment.locale('zh-cn')
			const time = moment.duration(seconds, 'seconds')
			const hours = time.hours()
			const minutes = time.minutes()
			const ss = time.seconds()
			const milliseconds = time.milliseconds().toFixed(0)
			const arr = []
			if (isHours) arr.push(hours < 10 ? `0${hours}` : hours)
			arr.push(minutes < 10 ? `0${minutes}` : minutes)
			arr.push(ss < 10 ? `0${ss}` : ss)
			if (isMill) arr.push(milliseconds < 10 ? `0${milliseconds}` : milliseconds)
			return arr.join(':')
		},

		// 打开dialog
		// 数据重置
		openDialog(data) {
			this.formData.name = data.name
			this.oldAyncJsonVal = data?.sync_json_val || '{}'
			this.id = data.id
			this.audioControl.isPlaying = false
			this.audioControl.duration = 0
			this.audioControl.currentTime = 0
			this.audioControl.playParcent = 0
			this.activePoint.time = undefined
			this.activePoint.index = undefined
			this.musciData = data
			this.musicLyricParse(data.abc_json_val?.url)
			this.formData.banchangUrl = data.music.find(item => +item.audio_type == 8)?.file_path?.url || ''
			this.formData.fanchangUrl = data.music.find(item => +item.audio_type == 9)?.file_path?.url || ''

			const sync_json_val = JSON.parse(data.sync_json_val || '{}')
			this.formData.points = sync_json_val?.points || []
			this.formData.beat = sync_json_val?.beat || 1
			this.formData.lyric = sync_json_val?.lyric || ''
			this.dialogControl.visible = true

			this.$nextTick(() => {
				/** @type {HTMLInputElement} */
				const input = this.$refs.millRef.$el.querySelector('input')
				input.setAttribute('readonly', 'true')
			})
			console.log('__data__', JSON.parse(data.sync_json_val))
		},

		// 10 毫秒加减
		activePointTimeChange(currentValue, oldValue) {
			if (currentValue > oldValue) {
				if (this.activePoint.time) {
					this.activePoint.time += 0.01
				}
			} else if (currentValue < oldValue) {
				if (this.activePoint.time) {
					this.activePoint.time -= 0.01
				}
			}
			this.formData.points[this.activePoint.index].time = this.activePoint.time
		},

		// 可以播放时
		// 获取总播放时长
		canplay() {
			this.audioControl.duration = this.$refs.audio.duration
		},

		// 当前播放时间进度变化
		// 百分比精度,2位小数
		timeupdate() {
			let currentTime = this.$refs.audio.currentTime
			let curParcent = +((currentTime / this.audioControl.duration) * 100).toFixed(2)
			this.audioControl.currentTime = currentTime
			this.audioControl.playParcent = curParcent
		},

		// 播放停止时
		audioPause(event) {
			this.audioControl.isPlaying = false
			if (event?.target?.ended) {
				this.audioControl.playParcent = 0
				this.audioControl.currentTime = 0
			}
		},

		// 播放
		play() {
			if (this.formData.fanchangUrl != '' && this.audioControl.duration != 0) {
				if (this.activePoint?.time) this.$refs.audio.currentTime = this.activePoint.time
				this.$refs.audio.play()
			}
		},

		// 暂停播放
		pause() {
			if (this.audioControl.isPlaying) {
				this.$refs.audio.pause()
			}
		},

		// 停止播放
		stop() {
			this.$refs.audio.pause()
			this.audioControl.isPlaying = false
			this.audioControl.isPlaying = false
			this.audioControl.playParcent = 0
			this.audioControl.currentTime = 0
			this.$refs.audio.currentTime = 0
			this.activePoint = {
				time: null,
				index: null,
				mill: null,
			}
		},

		// 解析谱音歌词
		// 把“空格”，“*”，“|”，替换为空字符；拆分，。
		async musicLyricParse(url) {
			this.abc_json_val.url = url
			this.abc_json_val.lyricArr = []
			if (!url) return
			/** @type {string} */
			const abcContent = (await axios.get(url)).data
			const lyricStrArr = abcContent.match?.(/(?<=w:).+/g) || []
			if (lyricStrArr.length) {
				const arrListArr = lyricStrArr.map(str => str?.replace(/\s+|\*|\|/g, '')?.split(/\，|。|？|！|；/g) || '')
				this.abc_json_val.lyricArr = arrListArr.flat().filter(v => v)
			}

			this.abcContent = abcContent
		},

		writeLyric() {
			if (this.abc_json_val.lyricArr?.length) {
				this.formData.lyric = this.abc_json_val.lyricArr.join('\n')
			}
		},

		// 卡点、标记点
		markerPoint() {
			let point = { time: this.audioControl.currentTime, type: 'point' }
			if (point.time == 0) return
			if (this.formData.points.some(v => v.time == point.time)) return
			this.formData.points.push(point)
			this.selectPoint(point, this.formData.points.length - 1)
		},

		// 选中点标记
		selectPoint(point, index) {
			this.activePoint.time = point.time
			this.activePoint.index = index
		},

		// 设置标记类型为music
		setPointMusic() {
			const index = this.activePoint.index
			const points = this.formData.points
			const point = points[index]
			if (point) {
				const type = { point: 'music', music: 'point' }[point.type || 'point']
				this.$set(point, 'type', type)
			}
		},

		// 删除卡点
		deletePoint() {
			let time = this.activePoint.time
			if (!time) return
			let index = this.formData.points.findIndex(point => point.time == time)
			if (index == -1) return
			this.formData.points.splice(index, 1)
		},

		// 重置卡点
		resetPoints() {
			this.$confirm('该操作将会清空卡点并重置，是否继续？', {
				closeOnClickModal: false,
				showClose: false,
				showCancelButton: true,
				title: '重置提示',
				confirmButtonText: '确认'
			}).then(() => {
        this.stop()
				this.formData.points = []
			})
		},
		// 滑块按下时
		pointMousedown(i) {
			const parent = this.$refs.points.getBoundingClientRect()
			// const leftPoint = this.formData.points[i - 1]
			// const rightPoint = this.formData.points[i + 1]
			const duration = this.audioControl.duration

			const setTime = time => {
				this.formData.points[i].time = time
				this.activePoint.time = time
				this.activePoint.index = i
			}

			setTime(this.formData.points[i].time, i)

			// 滑块移动时
			document.onmousemove = event => {
				let left = event.clientX - parent.x

				// 左侧边界检测
				if (left < 0) {
					setTime(0)
					return
				}

				// 移动位置计算成百分比（百分比）
				// 百分比转换成秒数
				let seconds = +(duration * (left / parent.width)).toFixed(5)

				// // 和左侧相邻点重叠时
				// if (leftPoint && parseInt(seconds) <= parseInt(leftPoint.time)) {
				// 	return setTime(leftPoint.time + 1)
				// }

				// // 和右侧相邻点重叠时
				// if (rightPoint && parseInt(seconds) >= parseInt(rightPoint.time)) {
				// 	seconds = rightPoint.time - 1
				// }

				// 右侧边界检测
				if (seconds > duration) {
					return setTime(duration)
				}

				setTime(seconds)
			}

			// 抬起
			document.onmouseup = function () {
				this.onmouseup = null
				this.onmousemove = null
				document.onmousemove = null
				document.onmouseup = null
			}

			// 解决有些时候,在鼠标松开的时候,元素仍然可以拖动-使用的是第二种方式
			document.ondragstart = function (ev) {
				ev.preventDefault()
			}
			document.ondragend = function (ev) {
				ev.preventDefault()
			}
		},
		async saveData(isSave = true) {
			// 数据重新排序
			this.formData.points = this.formData.points.sort((a, b) => a.time - b.time)
			let lyric = this.formData.lyric
			let points = this.formData.points
			let lyricArr = lyric.split('\n')

			const markerPoints = points.map((v, i) => ({
				time: v.time,
				index: i,
				type: v.type || 'point',
				lyric: lyricArr?.[i] || '' // 匹配的歌词
			}))

			console.log('markerPoints -> ', markerPoints)

			// 判断是否有超50字的歌词
			let longExceedIndex = markerPoints.findIndex(point => point.lyric?.length > 50)
			if (longExceedIndex !== -1) {
				this.$message({
					message: `第${longExceedIndex + 1}句歌词 “${markerPoints[longExceedIndex].lyric}” 超出50个字`,
					type: 'error'
				})
				return
			}

			const sync_json = JSON.stringify({
				lyric,
				points,
				markerPoints,
				beat: this.formData.beat
			})

			if (isSave == false) return sync_json

			await this.$api.bureau.lryicSync(this.id, { sync_json })
			this.dialogControl.visible = false
			this.$message({
				message: '跟唱同步保存成功',
				type: 'success'
			})
			this.$emit('success')
		},
		async openPreview() {
			const id = this.musciData.id
			const bangchang = this.musciData.music.find(item => item.audio_type == '8')
			const fangchang = this.musciData.music.find(item => item.audio_type == '9')
			const sync_json_val = await this.saveData(false)
			if (!sync_json_val) return
			window.top.music_datas = {
				[`${id}`]: {
					visibility: {
						title: true,
						subhead: true,
						anAuthor: true,
						wordAuthor: true,
						speed: true,
						attr1: true,
						attr2: true,
            singAlongTitle: true
					},
					VOCAL_JSON: {
						ABC_CONTENT: this.abcContent,
						BANCHANG_URL: bangchang?.file_path?.url || '',
						BANCHANG_WXP_BARLINE:
							JSON.parse(
								bangchang?.new_timeline || bangchang?.new_timeline != 'null'
									? bangchang?.new_timeline != ''
										? bangchang?.new_timeline
										: '{}'
									: '{}'
							)?.NODELINE_WXP || '[]',
						FANCHANG_URL: fangchang?.file_path?.url || '', // 9
						FANCHANG_WXP_BARLINE:
							JSON.parse(
								fangchang?.new_timeline || fangchang?.new_timeline != 'null'
									? fangchang?.new_timeline != ''
										? fangchang?.new_timeline
										: '{}'
									: '{}'
							)?.NODELINE_WXP || '[]',
						KNOWLEDGE_ID: 1,
						KNOW_TEAC_ID: 1,
						PAGE: 1,
						// SHOW_TYPE: 'gc'
						SHOW_TYPE: 'wxp'
					},
					abcResData: this.musciData,
					sync_json_val,
					tracks: '[]'
				}
			}

			this.$refs.preview?.openDialog(id)
		}
	}
}
</script>

<style lang="scss" scoped>
// .sing-synchroel-dialog /deep/ .el-dialog {
// 	// background: red;
// }

.sing-synchroel-container {
	width: 100%;
	padding-bottom: 40px;
	box-sizing: border-box;
	border-top: 1px solid #e9e9e9;
	border-bottom: 1px solid #e9e9e9;
}

.progress {
	padding: 0 20px;
	padding-top: 44px;
	padding-bottom: 8px;
	border: 1px solid #e9e9e9;
	border-radius: 6px;
	margin-top: 15px;

	.points {
		height: 20px;
		width: 100%;
		position: relative;
	}

	.progress-box {
		display: flex;
		align-items: center;
		flex: 1;
		span {
			font-size: 18px;
			color: #818181;
		}
		.point-control {
			width: 40px;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 7px;
			border: 1px solid #e0e0e0;
			background: #fff;
			&.can-btn {
				background: #ededed;
				border-color: #ededed;
				cursor: pointer;
			}
		}
	}

	.point-times {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		position: relative;
	}
}

.sing-synchroel-ctx {
	display: flex;
	align-items: center;
	margin-top: 20px;
	height: 362px;
}

.ctx-item {
	flex: 1;
	height: 100%;
	width: 100%;
	border: 1px solid #d4d4d4;
	background: #f9fafc;
	border-radius: 6px;
}

.ctx-lyric {
	@extend .ctx-item;
	margin-right: 20px;
	padding: 0 20px;
	display: flex;
	box-sizing: border-box;
	flex-direction: column;

	.ctx-lyric-title {
		font-size: 16px;
		font-weight: bold;
		color: #2c2c2c;
		padding: 10px 0;
		box-sizing: border-box;
		display: flex;
		align-items: center;

		span {
			font-size: 12px;
			color: #7d7d7d;
		}
	}

	.ctx-lyric-list {
		width: 100%;
		flex: 1;
		/deep/ .el-textarea__inner {
			font-size: 14px;
			color: #303030;
			line-height: 28px;
			font-family: '微软雅黑';
		}
	}
}

.ctx-controls {
	@extend .ctx-item;
	padding: 20px;
	box-sizing: border-box;

	.music-upload {
		display: flex;
		align-items: center;

		.upload-item {
			color: #323232;
			font-size: 14px;
			margin-right: 60px;
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 86px;

			.mp3-icon {
				border: 1px solid #c9c9c9 !important;
				border-radius: 3px;
				cursor: pointer;
				position: relative;
				overflow: hidden;
				background: #fff !important;
				font-size: 40px;
				color: #d9d9d9;
				width: 86px;
				height: 79px;
				line-height: 79px;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.upload-btn {
				width: 86px;
				height: 79px;
				border: 1px solid #c9c9c9;
				border-radius: 3px;
				background: #ffffff;
				display: flex;
				align-items: center;
				justify-items: center;
			}
		}
	}
}
</style>
